module.exports = __webpack_public_path__ + "img/badge-expertise-silver-brightbg.963f1da9.svg";